<template>
  <TagView>
    <div
      class="is-flex is-align-items-center is-clickable citation-wrapper is-radius-medium px-1 has-text-grey is-full-height"
      :data-e2e="AICypressAttribute.views.CLARA_CITATION_PILL"
    >
      <img :src="document.sourceEnum?.icon" class="source-icon" />
      <span class="m-l-5 is-size-6 overflow-hidden whitespace-no-wrap">
        {{ document.title }}
      </span>
    </div>
  </TagView>
</template>

<script>
import { EstateRagDocumentObject } from '@/modules/ai/models/EstateRagDocumentObject';
import TagView from '@/modules/core/ui/components/wrappers/TagView.vue';
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraCitationPill',
  components: { TagView },
  props: {
    document: {
      type: EstateRagDocumentObject
    }
  },
  static: {
    AICypressAttribute
  }
};
</script>

<style scoped>
span.tag {
  padding: 0 !important;
  position: relative;
  bottom: var(--ce-2px);
  transition: all 0.3s ease;

  .citation-wrapper {
    max-width: var(--ce-125px);
    height: var(--ce-20px);

    & > span {
      text-overflow: ellipsis;
      font-size: var(--ce-10px);
    }

    .source-icon {
      height: var(--ce-13px);
      opacity: 0.5;
    }
  }

  &:hover {
    background-color: var(--ce-primary-light-30) !important;

    .source-icon {
      opacity: 1;
    }

    span {
      color: var(--ce-black) !important;
    }
  }
}
</style>
